import Request from './request.js'
export default class {
  goBack () {
    this.$emit('gobackClick')
  }
}
